import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
const COUNTDOWN_DURATION = 10 * 60;
const STORAGE_KEY = 'proyecto-patriarca-countdown';
export function CountdownBanner() {
  const [timeLeft, setTimeLeft] = useState<number>(COUNTDOWN_DURATION);
  const [isUrgent, setIsUrgent] = useState(false);
  useEffect(() => {
    const storedExpiry = localStorage.getItem(STORAGE_KEY);
    const now = Date.now();
    let expiryTime: number;
    if (storedExpiry) {
      expiryTime = parseInt(storedExpiry, 10);
      const remaining = Math.max(0, Math.floor((expiryTime - now) / 1000));
      if (remaining === 0) {
        expiryTime = now + COUNTDOWN_DURATION * 1000;
        localStorage.setItem(STORAGE_KEY, expiryTime.toString());
        setTimeLeft(COUNTDOWN_DURATION);
      } else {
        setTimeLeft(remaining);
      }
    } else {
      expiryTime = now + COUNTDOWN_DURATION * 1000;
      localStorage.setItem(STORAGE_KEY, expiryTime.toString());
      setTimeLeft(COUNTDOWN_DURATION);
    }
    const interval = setInterval(() => {
      const now = Date.now();
      const remaining = Math.max(0, Math.floor((expiryTime - now) / 1000));
      setTimeLeft(remaining);
      setIsUrgent(remaining <= 120);
      if (remaining === 0) {
        expiryTime = now + COUNTDOWN_DURATION * 1000;
        localStorage.setItem(STORAGE_KEY, expiryTime.toString());
        setTimeLeft(COUNTDOWN_DURATION);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const scrollToOffer = () => {
    const offerSection = document.getElementById('offer');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <div className="w-full bg-gradient-to-r from-navy-dark via-navy-medium to-navy-dark border-b border-gold/30 relative overflow-hidden" data-id="element-1">
      {/* Subtle shimmer effect */}
      <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-gold/5 to-transparent" animate={{
      x: ['-100%', '100%']
    }} transition={{
      duration: 3,
      repeat: Infinity,
      ease: 'linear'
    }} data-id="element-2" />

      <div className="max-w-6xl mx-auto flex items-center justify-center gap-3 md:gap-6 py-2.5 px-4 relative z-10" data-id="element-3">
        <motion.div animate={isUrgent ? {
        scale: [1, 1.2, 1]
      } : {}} transition={isUrgent ? {
        duration: 0.8,
        repeat: Infinity
      } : {}} data-id="element-4">
          <FlameIcon className="w-4 h-4 text-gold" aria-hidden="true" data-id="element-5" />
        </motion.div>

        <p className="font-body text-sm md:text-base text-gray-300" data-id="element-6">
          <span className="text-white font-semibold" data-id="element-7">76% OFF</span>
          <span className="mx-2 text-gold/40" data-id="element-8">•</span>
          Oferta expira en
        </p>

        <div className="flex items-center gap-1.5" data-id="element-9">
          <TimeBlock value={minutes} label="min" isUrgent={isUrgent} data-id="element-10" />
          <span className="text-gold font-heading text-lg font-bold" data-id="element-11">:</span>
          <TimeBlock value={seconds} label="seg" isUrgent={isUrgent} data-id="element-12" />
        </div>

        <button onClick={scrollToOffer} className="hidden md:inline-flex items-center font-heading text-xs uppercase tracking-wider text-navy-dark bg-gold hover:bg-gold-light px-4 py-1.5 rounded-full transition-colors duration-200 font-bold" data-id="element-13">
          Comprar Ahora
        </button>
      </div>
    </div>;
}
function TimeBlock({
  value,
  label,
  isUrgent
}: {
  value: number;
  label: string;
  isUrgent: boolean;
}) {
  return <div className="flex flex-col items-center" data-id="element-14">
      <motion.span key={value} initial={{
      y: -4,
      opacity: 0.5
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      duration: 0.2
    }} className={`font-heading text-lg md:text-xl font-bold tabular-nums leading-none ${isUrgent ? 'text-red-400' : 'text-gold'}`} data-id="element-15">
        {value.toString().padStart(2, '0')}
      </motion.span>
      <span className="font-body text-[10px] text-gray-500 uppercase tracking-wider leading-none mt-0.5" data-id="element-16">
        {label}
      </span>
    </div>;
}